<template>
  <div>
    <p class="error">{{ error }}</p>
    <p class="text-warning">QRを読み込んでください</p>
    <qrcode-stream @decode="onDecode" @init="onInit" />
    <p class="codeinput">
    <span class="btn btn-warning btn-block" v-on:click="toStampCode()" >番号で入力</span></p>
  </div>
</template>
<script>
import sx from '../utils/core.js'
import { QrcodeStream } from 'vue-qrcode-reader';
export default {
  created () {
    this.$store.state.title = 'スキャナー'
    this.$store.state.showBack = true
    this.$store.state.pageBack = 'Stamp'
    if (sx.isNothingOrEmpty(this.$store.state.stampid)) {
      this.$router.replace({ name: 'Stamp' })
    }
  },
  mounted () {
    if (sx.isNothingOrEmpty(this.$store.state.stampid)) {
      this.$router.replace({ name: 'Stamp' })
    }
  },
  destroyed () {
    this.$store.state.showBack = false
  },
  components: { QrcodeStream },
  data () {
    return {
      result: '',
      error: ''
    }
  },
  methods: {
    toStampCode() {
      this.$router.replace({ name: 'StampCode' })
    },
    onDecode (result) {
      const that = this
      if (result != "38830303003") {
        sx.toastError(result + '<br>スタンプ押印QRコードが不正です！')
      } else {
        var params = {
          corpid: 40,
          bucketid: '17',
          stampid: that.$store.state.stampid,
          token: localStorage.getItem('token')
        }
        var url = that.$store.state.baseurl + '/app/mshelper/addStamp'
        sx.request(
          url,
          params,
          function(result) {
            if (result.status === 'ok') {
              setTimeout(function () {
                sx.toastSuccess('スタンプを受け取りました！')
                that.$router.replace({ name: 'Stamp' })
              }, 1000);
              sx.hideWaiting()
            } else {
              sx.toastSuccess(result.message)
              console.log(result.message)
              sx.hideWaiting()
            }
          },
          function() {
            sx.login(
              url,
              params,
              function(result) {
                if (result.status === 'ok') {
                  setTimeout(function () {
                    sx.toastSuccess('スタンプを受け取りました！')
                    that.$router.replace({ name: 'Stamp' })
                  }, 1000);
                  sx.hideWaiting()
                } else {
                  sx.toastSuccess(result.message)
                  console.log(result.message)
                  sx.hideWaiting()
                }
              },
              function() {
                console.log("wrong")
              }
            )
          }
        )
      }
    },
    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name == 'NotAllowedError') {
          this.error = "ERROR: カメラをアクセス権限がありません"
        } else if (error.name == 'NotFoundError') {
          this.error = "ERROR: 端末はカメラがありません"
        } else if (error.name == 'NotSupportedError') {
          this.error = "ERROR: セキュリティ不備(HTTPS、ローカルホスト)"
        } else if (error.name == 'NotReadableError') {
          this.error = "ERROR: カメラが占用されています"
        } else if (error.name == 'OverconstrainedError') {
          this.error = "ERROR: カメラ設置エラー"
        } else if (error.name == 'StreamApiNotSupportedError') {
          this.error = "ERROR: ブラウザはストリームAPIをサポートしていません"
        } else {
          this.error = "ERROR: 原因不明エラー " + error
        }
      }
    }
  }
}
</script>
<style scoped>
.error {
  font-weight: bold;
  color: red;
}
.codeinput{
  padding:5px
}
</style>
